import type { AuthorizedCard } from '@shared/cards-types';
import { useProductData } from '@shared/products-core';

import { useAuthorizedCards } from './useAuthorizedCards';

interface UseAuthorizedCardsState {
    isPending?: boolean;
    error?: unknown;
    authorizedCards?: AuthorizedCard[];
}

export const useAuthorizedCardsByProductId = (productId: string): UseAuthorizedCardsState => {
    const { product } = useProductData(productId);

    const {
        isPending,
        error,
        data: authorizedCards = [],
    } = useAuthorizedCards(product?.underlyingCard);

    return {
        isPending,
        error,
        authorizedCards,
    };
};
